module.exports = __webpack_public_path__ + "img/revista-madrigal-01.4031d1ef.jpg";